export default __webpack_public_path__ + "static/hero-chip-illustration-mobile-eac299e2542a1d23fa8b52107de3b52c.png";